const VehicleDetail = {
  validHeader: {
    'Vehicle Number': 'vehicle_id',
    'Vehicle Name': 'vehicle_type',
    'Chassis Number': 'vehicle_chassis_no',
    'Vehicle Model': 'vehicle_model',
    Depot: 'depot_ref_id',
    Transporter: 'transporter_ref_id',
    'Tare Weight': 'tare_weight',
    'Vehicle Length': 'vehicle_length',
    'Vehicle Width': 'vehicle_width',
    'Vehicle Height': 'vehicle_height',
    'Vehicle uom': 'vehicle_uom',
    'Vehicle Filled Weight': 'vehicle_filled_weight',
    'Vehicle Gross Weight': 'vehicle_gross_weight',
    'Vehicle Volume': 'vehicle_volume',
    'Induction Date(YYYY/MM/DD)': 'induction_date',
    'Induction End Date(YYYY/MM/DD)': 'induction_end_date',
    'PIMC Expiry Date(YYYY/MM/DD)': 'pimc_expiry_date',
    'Engine Number': 'engine_number',
    'Insurance Validity(YYYY/MM/DD)': 'insurance_validity',
    'Fitness Validity(YYYY/MM/DD)': 'fitness_validity',
    'Fleet Type': 'fleet_type',
    'Vehicle Status': 'vehicle_status',
  },
};

const vehicleDetailsStatus = {
  ACTIVE: 'ACTIVE',
  BLACKLISTED: 'BLACKLISTED',
};

const VehicleStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
}

const FleetTypes = {
  own: 'own',
  dedicated: 'dedicated',
  market: 'market',
};

module.exports = { VehicleDetail, vehicleDetailsStatus, FleetTypes, VehicleStatus };
